export default {
  sm: `
  DATA CENTER GAK acts for
  zero carbon emissions
  `,
  lg: `
  DATA CENTER GAK acts for zero carbon emissions
  `,
};
